import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, ModalFooter, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Button from '../../../components/Button';
import ModalHeader from '../../../components/ModalHeader';
import Tabs from '../../../components/Tabs/Tabs';
import Blockquote from '../../../components/Blockquote';
import HealthBenefits from '../../private/benefitCostWorksheetTabPages/healthBenefits'
import AllBenefits from '../../private/benefitCostWorksheetTabPages/allBenefits';


export type customBenefitOptionsAndCostsCobraProps = {
  showBenefitOptionsAndCostsCobra: boolean;
  handleCloseBenefitOptionsAndCostsCobra: () => void;
};

const BenefitOptionsAndCostsCobra = ({
  showBenefitOptionsAndCostsCobra,
  handleCloseBenefitOptionsAndCostsCobra,
}: customBenefitOptionsAndCostsCobraProps) => {

  const tabsData = [
    {
      name: 'Health Benefits',
      content: <HealthBenefits />,
    },
    {
      name: 'All Benefits',
      content: <AllBenefits />,
    },
  ];

  return (
    <Modal
      show={showBenefitOptionsAndCostsCobra}
      onHide={handleCloseBenefitOptionsAndCostsCobra}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefit Cost Worksheet</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Container
            className={'col-12 border-bottom pb-10'}
          >
          <Row>
          <Col className={'col-8 px-0 mt-2'}> <div>Event: <span className="fw-bold">Enroll in COBRA coverage </span></div>
           <div className={'mt-2'}>Date: <span className="fw-bold">1/1/2024</span></div> 
            </Col>
           <Col className={'col-4 text-end px-0 mt-3'}>
            <a
              className={'text-decoration-none'}
              href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
              target={'_blank'}
              rel="noreferrer"
            >
              <Button
                leftIcon={light('file-arrow-down')}
                variant="primary"
                className={'order-1 order-lg-3 mt-7 mt-lg-0'}
                size="sm"
              >
                Download/Print
              </Button>
            </a>
            </Col>
            </Row>
          </Container>
          
          <div className={'d-none d-lg-block mt-10'}>
            <Blockquote variant="primary">
              <div className={'mt-2 text-ligther-grey'}>
                <b>Important: </b>If you don’t make a different election, you’ll receive the highlighted coverage. 
              </div>
              <div className='mt-2'>
                <b>Note</b>
                <ul>
                  <li>This worksheet is for planning purposes only.</li>
                  <li>Coverage eligibility may change depending on the actual date of the event.</li>
                  <li>After you make new elections on the ‘Enroll in Benefits’ step, your cost for coverage may change.</li>
                </ul>
              </div>
            </Blockquote>
          </div>

          <Row>
          <Col className="m-0 p-0 mt-12">
            <Tabs tabs={tabsData} variant={'horizontal'} />
          </Col>
          </Row>
 
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseBenefitOptionsAndCostsCobra}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BenefitOptionsAndCostsCobra;
